import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_TAGGED_WORD_HISTORY } from '@/graphql/trainerTag';
import { bizmatesWordbookApi } from '@/utils/bizmatesApi';
import store from '@/store';

import logger from '@/modules/Logger';

/*
* Get the saved tags on word(s)/phrase(s)
*/
export const GetTaggedWordHistoryService = {
  msb: async (studentBookId) => {
    logger.debug(`[Trainer Tag] Get Tagged Word History using MSB GraphQL endpoint`, {
      operation: 'trainer-tag:history'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.query({
      query: GET_TAGGED_WORD_HISTORY,
      variables: {
        student_book_id: studentBookId
      }
    });

    store.commit('socketio/insertTrainerTag', data?.getTaggedWordHistory);
  },

  legacy: async (studentBookId) => {
    logger.debug(`[Trainer Tag] Get Tagged Word History using legacy endpoint`, {
      operation: 'trainer-tag:history'
    });

    const params = {
      lesson_id: studentBookId
    };

    await bizmatesWordbookApi.get('trainertag', { params }, response => {
      if (response.data.data) {
        store.commit('socketio/insertTrainerTag', response.data.data);
      }
    }, err => {
      logger.error('[GET] Get Tagged Word error: ' + err.message, { operation: 'trainer-tag:get', event_type: 52 });
    });
  }
};
